document.addEventListener('DOMContentLoaded', function () {
  const card = document.getElementById('west-leyden-card');
  const modal = document.getElementById('west-leyden-modal');
  const modalImg = document.getElementById('west-leyden-modal-img');
  const prevBtn = document.getElementById('west-leyden-prev');
  const nextBtn = document.getElementById('west-leyden-next');
  const closeBtn = document.getElementById('west-leyden-close');

  if (!card || !modal || !modalImg) return;

  const images = [
    'assets/projects/west-leyden/IMG_0469.webp',
    'assets/projects/west-leyden/IMG_0472.webp',
    'assets/projects/west-leyden/IMG_0477.webp',
    'assets/projects/west-leyden/IMG_0479.webp',
    'assets/projects/west-leyden/IMG_0483.webp',
    'assets/projects/west-leyden/IMG_0485.webp',
    'assets/projects/west-leyden/IMG_0487.webp'
  ];

  let idx = 0;
  let indicatorButtons = [];
  const counterEl = document.getElementById('west-leyden-counter');
  const dotsContainer = document.getElementById('west-leyden-dots');

  function show() {
    modalImg.src = images[idx];
    if (indicatorButtons && indicatorButtons.length) {
      indicatorButtons.forEach((btn, i) => {
        if (i === idx) {
          btn.classList.add('bg-white');
          btn.classList.remove('bg-transparent');
        } else {
          btn.classList.remove('bg-white');
          btn.classList.add('bg-transparent');
        }
      });
    }
    if (counterEl) counterEl.textContent = (idx + 1) + ' of ' + images.length;
  }

  function createIndicators() {
    const container = document.getElementById('west-leyden-indicators');
    if (!container) return;
    if (container.dataset.inited) return;
    container.dataset.inited = '1';
    if (dotsContainer) {
      images.forEach((img, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'w-3 h-3 sm:w-4 sm:h-4 rounded-full transition-all duration-300 border-2 border-white';
        btn.classList.add(i === idx ? 'bg-white' : 'bg-transparent');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          idx = i;
          show();
        });
        dotsContainer.appendChild(btn);
        indicatorButtons.push(btn);
      });
    }
  }

  function openAt(i) {
    idx = i || 0;
    show();
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    createIndicators();
  }

  function close() {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  card.addEventListener('click', function () {
    openAt(0);
  });

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      idx = (idx - 1 + images.length) % images.length;
      show();
    });
    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      idx = (idx + 1) % images.length;
      show();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
  }

  modal.addEventListener('click', function (e) {
    if (e.target === modal) close();
  });

  document.addEventListener('keydown', function (e) {
    if (modal.classList.contains('hidden')) return;
    if (e.key === 'Escape') return close();
    if (e.key === 'ArrowLeft') {
      idx = (idx - 1 + images.length) % images.length;
      show();
    }
    if (e.key === 'ArrowRight') {
      idx = (idx + 1) % images.length;
      show();
    }
  });

  // Touch swipe support
  let startX = 0;
  let endX = 0;
  const threshold = 40;
  let lastTap = 0;
  modalImg.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  modalImg.addEventListener('touchmove', function (e) {
    endX = e.touches[0].clientX;
  }, { passive: true });
  modalImg.addEventListener('touchend', function (e) {
    const now = Date.now();
    if (now - lastTap < 350) {
      if (e.cancelable) e.preventDefault();
      lastTap = 0;
      return;
    }
    lastTap = now;
    const dx = endX - startX;
    if (Math.abs(dx) > threshold) {
      if (dx < 0) {
        idx = (idx + 1) % images.length;
      } else {
        idx = (idx - 1 + images.length) % images.length;
      }
      show();
    }
    startX = 0; endX = 0;
  }, { passive: false });

});
